import { inject } from '@angular/core';
import { OrganizationsStore } from '../store/organizations.store';

export const organizationsLoadedGuard = () => {
  const store = inject(OrganizationsStore);
  // if orga fetch was not triggered yet, trigger it
  if (!store.allLoaded() && !store.allLoading() && !store.allLoadingError()) {
    // trigger loading without waiting for the result to display loading states in the ui
    void store.loadAll();
    return true; // let the route activate, we will redirect later in the OrganizationsPage if needed
  }
  return true;
};
